import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import LocationEditPopup from '~/apps/shared/containers/locations/LocationEditPopup';


export default function({ locationId }) {
  return (
    <CurrentOrgInjector
      component={LocationEditPopup}
      locationId={locationId}
      onReturn={() => navigate('sender.locations')}
    />
  );
};
